import apiWorker from '../apiWorker'

const internal_costs = {
    byCompany : (company_id, query) =>  apiWorker('get', `/v1/admin/internal_costs/company/${company_id}${query}`),
}

export default internal_costs;